module.exports = __webpack_public_path__ + "static/media/MilindaWattegedara.3d03dd74.png";